<template>
    <AppSurvey />
</template>

<script>
import ANALYTICS from '@generio-ai/library-legacy/constants/analytics'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import AppSurvey from '@/components/survey/AppSurvey.vue'

export default {
    name: 'ViewSurvey',
    components: {
        AppSurvey
    },
    methods: {
        ...mapActions('analytics', [
            'logEvent'
        ]),
        ...mapActions('overlay', [
            'hide'
        ]),
    },
    mounted() {
        this.hide()
        this.logEvent({
            name: ANALYTICS.EVENTS.VIEW_OPENED,
            description: 'Survey view opened',
        })
    }
}
</script>